import { Button, CopyButton, Heading, Loading, Text, useMatchBreakpoints } from '@pancakeswap/uikit'
import Link from 'next/link'
import AddToWalletButton from 'components/AddToWallet/AddToWalletButton'
import { Token, WETH9 } from '@pancakeswap/sdk'
import axios from 'axios'
import ConnectWalletButton from 'components/ConnectWalletButton'
import Page from 'components/Layout/Page'
import { ROUTER_ADDRESS } from 'config/constants/exchange'
import { ethers } from 'ethers'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useEffect, useState, useCallback, useRef } from 'react'
import { useSigner } from 'wagmi'
import { multiChainName } from 'state/info/constant'
import { fetchDerivedUSDPricePerAddress } from 'state/info/queries/pools/poolData'
import { formatEther, parseEther, parseUnits } from '@ethersproject/units'
import TransactionConfirmationModal from 'components/TransactionConfirmationModal'
import Tooltip from '@mui/material/Tooltip'
import { Slider } from './components/Slider'
import { abi as TokenAbi, bytecode as TokenByteCode } from '../../config/abi/token.json'
import TokenCard from './components/Slider/TokenCard'
import {
  Container,
  Section,
  Input,
  FileInputContainer,
  FileName,
  ResumeSection,
  ModalContainer,
  ResponsiveFlex,
  DeployedTokenSection,
  CopyButtonContainer,
  ScrollableRow,
} from './styles'

const deployedTokenApi = 'https://deployedtokensapi.9inch.io'

export default function LaunchPad() {
  const { data: signer } = useSigner()
  const { account, chainId } = useActiveWeb3React()

  const [tokenName, setTokenName] = useState('')
  const [tokenSymbol, setTokenSymbol] = useState('')
  const [tokenSupply, setTokenSupply] = useState('')
  const [ethPlsAmount, setEthPlsAmount] = useState('')
  const [initialPrice, setInitialPrice] = useState(0)
  const [marketCap, setMarketCap] = useState(0)
  const [liquidityTokenAmount, setPoolTokenAmount] = useState('')
  const [poolAllocationTokenAmount, setPoolAllocationTokenAmount] = useState('')
  const [fileName, setFileName] = useState('')
  const [logoFile, setLogoFile] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [tokenLogoUrl, setTokenLogoUrl] = useState(undefined)
  const [nativeCoinName, setNativeCoinName] = useState('ETH')
  const [recentDeployedTokens, setRecentDeployedTokens] = useState([])
  const { isMobile } = useMatchBreakpoints()

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [transactionStatus, setTransactionStatus] = useState({
    attemptingTxn: false,
    hash: '',
    succeeded: false,
    failed: false,
    rejection: false,
    message: '',
  })

  const [tokenConfig, setTokenConfig] = useState({
    name: '',
    symbol: '',
    supply: '0',
    router: '',
    ethLiquidityAmount: ethPlsAmount ? parseEther(ethPlsAmount).toString() : '0',
    tokenLiquidityAmount: liquidityTokenAmount ? parseEther(liquidityTokenAmount).toString() : '0',
    amountForPool: poolAllocationTokenAmount ? parseEther(poolAllocationTokenAmount).toString() : '0',
  })

  const [deployedToken, setDeployedToken] = useState(null)
  const [deployedTokens, setDeployedTokens] = useState([])

  useEffect(() => {
    if (chainId === 369 || chainId === 943) {
      setNativeCoinName('PLS')
    } else {
      setNativeCoinName('ETH')
    }
  }, [chainId])

  const sendTelegramMessage = async (address, name, symbol, supply) => {

    const text = `<b>New Token Deployed</b> 🚀

<b>Address:</b> <code>${address}</code>
<b>Name:</b> <code>${name}</code>
<b>Symbol:</b> <code>${symbol}</code>
<b>Supply:</b> <code>${supply}</code>
        `


    const BOT_TOKEN = process.env.NEXT_PUBLIC_TG_BOT_URL_APIKEY
    const CHAT_ID = process.env.NEXT_PUBLIC_CHAT_ID
    fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      // body: '{"chat_id": "123456789", "text": "This is a test from curl", "disable_notification": true}',
      body: JSON.stringify({
        chat_id: CHAT_ID,
        text,
        parse_mode: 'HTML',
      }),
    })
      .then((response) => {
        console.log(response)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const deploy = async () => {
    setIsLoading(true)
    setTransactionStatus({ ...transactionStatus, attemptingTxn: true })
    setIsModalVisible(true)

    // validations
    if (!tokenName) {
      alert('Token name is required')
      setIsLoading(false)
      setIsModalVisible(false)
      return
    }

    if (!tokenSymbol) {
      alert('Token symbol is required')
      setIsLoading(false)
      setIsModalVisible(false)
      return
    }

    if (!tokenSupply) {
      alert('Token supply is required')
      setIsLoading(false)
      setIsModalVisible(false)
      return
    }

    setTokenConfig({
      name: tokenName,
      symbol: tokenSymbol,
      supply: parseEther(tokenSupply).toString(),
      router: ROUTER_ADDRESS[chainId],
      ethLiquidityAmount: ethPlsAmount ? parseEther(ethPlsAmount).toString() : '0',
      tokenLiquidityAmount: liquidityTokenAmount ? parseEther(liquidityTokenAmount).toString() : '0',
      amountForPool: poolAllocationTokenAmount ? parseEther(poolAllocationTokenAmount).toString() : '0',
    })

    const currentTokenConfig = {
      name: tokenName,
      symbol: tokenSymbol,
      supply: parseEther(tokenSupply).toString(),
      router: ROUTER_ADDRESS[chainId],
      ethLiquidityAmount: ethPlsAmount ? parseEther(ethPlsAmount).toString() : '0',
      tokenLiquidityAmount: liquidityTokenAmount ? parseEther(liquidityTokenAmount).toString() : '0',
      amountForPool: poolAllocationTokenAmount ? parseEther(poolAllocationTokenAmount).toString() : '0',
    }

    console.log(tokenConfig)

    try {
      setTransactionStatus((prevState) => ({ ...prevState, attemptingTxn: true, message: 'Deploying Token...' }))
      const contract = await deployToken(currentTokenConfig, signer)

      if (contract) {

        await sendTelegramMessage(contract.address, currentTokenConfig.name, currentTokenConfig.symbol, tokenSupply)

        await verify(contract.address, {
          chainId,
          name: currentTokenConfig.name,
          symbol: currentTokenConfig.symbol,
          supply: currentTokenConfig.supply,
          router: currentTokenConfig.router,
          amountForPool: currentTokenConfig.amountForPool,
        })

        // insert token to database

        await axios.post(`${deployedTokenApi}/insertToken`, {
          deployer: account,
          name: currentTokenConfig.name,
          symbol: currentTokenConfig.symbol,
          supply: currentTokenConfig.supply,
          chainId,
          tokenAddress: contract.address,
          logoUrl: tokenLogoUrl,
          deployTxHash: contract.deployTransaction.hash,
        })

        try {
          axios.get(`${deployedTokenApi}/userTokens?walletAddress=${account}`).then((response) => {
            const { data } = response
            console.log({
              data,
            })
            setDeployedTokens(data)
          })
        } catch (ex) {
          console.log(ex)
        }

        setTransactionStatus((prevState) => ({
          ...prevState,
          hash: contract.deployTransaction.hash,
          message: 'Verifying Contract...',
        }))

        const contractAddress = contract.address

        setDeployedToken({
          address: contractAddress,
          symbol: currentTokenConfig.symbol,
          decimals: 18, // Update this if your token has a different decimals count
        })

        // const shouldAddLiquidity =
        //   Number(currentTokenConfig.ethLiquidityAmount) > 0 && Number(currentTokenConfig.tokenLiquidityAmount) > 0
        const shouldAddLiquidity = false;
        if (shouldAddLiquidity) {
          setTransactionStatus((prevState) => ({ ...prevState, message: 'Adding Liquidity...' }))
          const txResponse = await contract.addLiquidity(
            currentTokenConfig.ethLiquidityAmount,
            currentTokenConfig.tokenLiquidityAmount,
            {
              value: currentTokenConfig.ethLiquidityAmount,
            },
          )

          await txResponse.wait()

          // Transaction was successful
          setTransactionStatus((prevState) => ({
            ...prevState,
            attemptingTxn: false,
            succeeded: true,
            hash: txResponse.hash,
            message: 'Liquidity Added Successfully',
          }))
        }

        setTransactionStatus((prevState) => ({
          ...prevState,
          attemptingTxn: false,
          succeeded: true,
          message: 'Deployment Successful',
          hash: contract.deployTransaction.hash,
        }))
      }
    } catch (error) {
      const e = error as any
      console.error('Deployment Error:', e)
      setTransactionStatus((prevState) => ({
        ...prevState,
        attemptingTxn: false,
        failed: true,
        rejection: e.code === 4001,
        message: e.code === 4001 ? 'Transaction Rejected' : 'Deployment Failed',
      }))
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (deployedToken) {
      console.log('Deployed Token Updated:', deployedToken)
    }
  }, [deployedToken])

  useEffect(() => {
    if (tokenConfig.name && tokenConfig.symbol) {
      console.log('tokenConfig has been updated:', tokenConfig)
    }
  }, [tokenConfig])

  useEffect(() => {
    if (transactionStatus) {
      console.log('Transaction Status has been updated:', transactionStatus)
    }
  }, [transactionStatus])

  const getDeployedContractInstance = (address) => {
    return new ethers.Contract(address, TokenAbi, signer)
  }

  /*
  const addLiquidity = async () => {
    console.log("Add liquidity for: ", tokenConfig.name)
    if (!deployedToken) {
      alert("Token must be deployed first");
      return;
    }

    setIsLoading(true);
    setTransactionStatus({ ...transactionStatus, attemptingTxn: true, message: "Adding Liquidity..." });
    setIsModalVisible(true);

    try {
      const contract = getDeployedContractInstance(deployedToken.address);

      await contract.addLiquidity(tokenConfig.ethLiquidityAmount, tokenConfig.tokenLiquidityAmount, {
        value: tokenConfig.ethLiquidityAmount,
      });

      setTransactionStatus(prevState => ({
        ...prevState,
        attemptingTxn: false,
        succeeded: true,
        message: "Liquidity Added"
      }));
    } catch (error) {
      // ...error handling...
    } finally {
      setIsLoading(false);
    }
  };
  */

  const deployToken = async (currentTokenConfig, signerInstance: ethers.Signer): Promise<ethers.Contract> => {
    try {
      console.log(currentTokenConfig.name)
      console.log(signerInstance)
      const factory = new ethers.ContractFactory(
        TokenAbi,
        Buffer.from(TokenByteCode.substring(2), 'hex'),
        signerInstance,
      )
      const contract = await factory.deploy(
        currentTokenConfig.name,
        currentTokenConfig.symbol,
        currentTokenConfig.supply,
        currentTokenConfig.router,
        currentTokenConfig.amountForPool,
      )
      await contract.deployed()
      await contract.deployTransaction.wait(1)
      return contract
    } catch (ex) {
      console.log(ex)
      setIsLoading(false)
      return null
    }
  }

  const verify = async (address, args) => {
    const url = 'https://verifyapi.9inch.io/verify'

    const chainName = args.chainId === 1 ? 'mainnet' : 'pulsechainmainnet'
    // const chainName = args.chainId === 11155111 ? "mainnet" : "pulsechaintestnet"

    const body = {
      chainName,
      address,
      name: args.name,
      symbol: args.symbol,
      supply: args.supply,
      router: args.router,
      amountForPool: args.amountForPool,
    }

    console.log({
      body,
    })

    try {
      const response = await axios.post(url, body, {
        headers: { 'Content-Type': 'application/json' },
      })
      console.log({
        response,
      })
      return response.data.result
    } catch (ex) {
      console.log(ex)
      return null
    }
  }

  async function uploadImageLogo(imagePath: File) {
    const NFT_STORAGE_API_KEY =
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweGJlQmMwQjEwNDk0YWJCRGUyYTVDNzNmMDc0MDgyOTNCMzU3OTk2NEEiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTcwMTE4ODQxMDMwOSwibmFtZSI6InNvbG1pbnRlciJ9.kTkAZ5mJ1OSpLs8huA8I_tK32kzL1CnrgETtoaDzytw'
    let imageUrl = ''
    try {
      const response = await axios.post('https://api.nft.storage/upload', imagePath, {
        headers: {
          accept: 'application/json',
          'Content-Type': 'image/*',
          Authorization: `Bearer ${NFT_STORAGE_API_KEY}`,
        },
      })
      console.log({
        response,
      })
      imageUrl = `https://${response.data.value.cid}.ipfs.nftstorage.link`
    } catch (ex) {
      console.log(ex)
    }
    return imageUrl
  }

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]

    if (file) {
      // get image file extension
      const extension = file?.name.split('.').pop()

      // check if file is an image
      if (
        extension.toLocaleLowerCase() !== 'png' &&
        extension.toLocaleLowerCase() !== 'jpg' &&
        extension.toLocaleLowerCase() !== 'jpeg'
      ) {
        alert('Only image png, jpg or jpge files are allowed')
        return
      }

      // check image file resolution
      const img = new Image()
      img.src = URL.createObjectURL(file)
      console.log({
        img,
      })

      // image resolution should be 512x512 to 1024x1024 pixels
      img.onload = async function () {
        if (img.width < 64 || img.height < 64 || img.width > 128 || img.height > 128) {
          alert('Image resolution should be 64x64 to 128x128 pixels')
          setFileName('')
          setLogoFile(null)
          // return;
        } else {
          setFileName(file.name)
          setLogoFile(file)
          console.log(file)
          const logoUrl = await uploadImageLogo(file)
          console.log({
            logoUrl,
          })
          setTokenLogoUrl(logoUrl)
        }
      }
    }
  }

  const handleTokenSymbolChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // const value = event.target.value.replace(/[^A-Za-z]/g, '').toUpperCase();
    const value = event.target.value
    setTokenSymbol(value)
  }

  const validateTokenName = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    setTokenName(value)
  }

  const validateInteger = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    if (value === '' || (/^\d*\.?\d*$/.test(value) && value.length <= 20)) {
      switch (event.target.name) {
        case 'tokenSupply':
          setTokenSupply(value)
          break
        case 'ethPlsAmount':
          setEthPlsAmount(value === '' ? '' : value)
          break
        case 'liquidityTokenAmount':
          setPoolTokenAmount(value === '' ? '' : value)
          break
        case 'poolTokenAllocationAmount':
          setPoolAllocationTokenAmount(value === '' ? '' : value)
          break
        default:
          break
      }
    }
  }

  const formatMarketCap = (value) => {
    if (value >= 1.0e15) return `${(value / 1.0e15).toFixed(2)}Q`
    if (value >= 1.0e12) return `${(value / 1.0e12).toFixed(2)}T`
    if (value >= 1.0e9) return `${(value / 1.0e9).toFixed(2)}B`
    if (value >= 1.0e6) return `${(value / 1.0e6).toFixed(2)}M`
    if (value >= 1.0e3) return `${(value / 1.0e3).toFixed(2)}k`
    return value.toFixed(2)
  }

  // function for calculate percentage of value given total and value
  const calculatePercentage = (total: number, value: number) => {
    // Ensure both total and value are numbers
    if (typeof total !== 'number' || typeof value !== 'number') {
      return '' // Return an empty string or a default value as appropriate
    }

    // Check for division by zero
    if (total === 0) {
      return '' // Return an empty string or a default value as appropriate
    }

    const percentage = (value / total) * 100
    return Number.isNaN(percentage) ? '' : `${percentage.toFixed(2)}%`
  }

  useEffect(() => {
    const fetchPricesAndCalculate = async () => {
      try {
        let ethPriceInUSD
        if (chainId === 943) {
          ethPriceInUSD = 0.00005631
        } else if (chainId === 11155111) {
          ethPriceInUSD = 2200
        } else {
          const fetchedPrice = await fetchDerivedUSDPricePerAddress(
            WETH9[chainId].address.toLowerCase(),
            multiChainName[chainId],
          )
          ethPriceInUSD = fetchedPrice.price
        }

        // Perform calculations
        const calcInitialPrice = (Number(ethPlsAmount) * ethPriceInUSD) / Number(liquidityTokenAmount)
        const calcMarketCap = calcInitialPrice * Number(tokenSupply)

        setInitialPrice(parseFloat(calcInitialPrice.toFixed(2)))
        setMarketCap(parseFloat(calcMarketCap.toFixed(2)))
      } catch (error) {
        console.error('Error fetching prices or calculating values:', error)
      }
    }

    if (ethPlsAmount && liquidityTokenAmount && tokenSupply) {
      fetchPricesAndCalculate()
    }
  })

  useEffect(() => {
    try {
      axios.get(`${deployedTokenApi}/userTokens?walletAddress=${account}`).then((response) => {
        const { data } = response
        console.log({
          data,
        })
        setDeployedTokens(data)
      })
    } catch (ex) {
      console.log(ex)
    }

    try {
      axios.get(`${deployedTokenApi}/recentDeployedTokens`).then((response) => {
        const { data } = response
        console.log({
          data,
        })
        setRecentDeployedTokens(data)
      })
    } catch (ex) {
      console.log(ex)
    }
  }, [chainId, account])

  const [percent, setPercent] = useState(0)

  const handleChangePercent = useCallback(
    (sliderPercent: number) => {
      setPercent(sliderPercent)
      setPoolAllocationTokenAmount((Number(tokenSupply) * (sliderPercent / 100)).toFixed(2))
    },
    [tokenSupply],
  )

  const increaseRef = useRef<HTMLDivElement>(null)
  const moveLeftRef = useRef<boolean>(true)

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (increaseRef.current) {
        if (increaseRef.current.scrollLeft === increaseRef.current.scrollWidth - increaseRef.current.clientWidth) {
          moveLeftRef.current = false
        } else if (increaseRef.current.scrollLeft === 0) {
          moveLeftRef.current = true
        }
        increaseRef.current.scrollTo(
          moveLeftRef.current ? increaseRef.current.scrollLeft + 1 : increaseRef.current.scrollLeft - 1,
          0,
        )
      }
    }, 20)

    return () => {
      clearInterval(scrollInterval)
    }
  }, [])

  return (
    <Page>
      <div>
        <Text textAlign={isMobile ? 'center' : 'left'}>Recently Deployed</Text>
        <ScrollableRow ref={increaseRef}>
          {recentDeployedTokens && recentDeployedTokens.length > 0 && (
            recentDeployedTokens.map((token) => (
              <TokenCard key={token.tokenAddress} token={token} />
            ))
          )}
        </ScrollableRow>
      </div>
      <Container>
        <Heading style={{ fontSize: '3rem', marginBottom: '5rem' }} marginBottom="1rem">
          Mint your token
        </Heading>

        <Section>
          <Tooltip title="Enter the desired name for your new token." placement="right-start">
            <Input placeholder="Token Name" value={tokenName} onChange={validateTokenName} maxLength={42} />
          </Tooltip>
          <Tooltip title="Choose a unique symbol for your token, typically 3-5 characters." placement="right-start">
            <Input placeholder="Token Symbol" value={tokenSymbol} onChange={handleTokenSymbolChange} maxLength={42} />
          </Tooltip>
          <Tooltip title="Specify the total number of tokens to be created." placement="right-start">
            <Input name="tokenSupply" placeholder="Token Supply" value={tokenSupply} onChange={validateInteger} />
          </Tooltip>
          <Tooltip
            title="Upload a logo for your token. Recommended size: 64x64px to 128x128px."
            placement="right-start"
          >
            <FileInputContainer>
              {tokenLogoUrl ? (
                <p style={{ textAlign: 'center', marginRight: '10px' }}>
                  <img
                    alt="logo"
                    src={tokenLogoUrl ?? ''}
                    style={{ borderRadius: '50%', width: '48px', height: '48px' }}
                  />
                  <br />
                </p>
              ) : null}

              <FileName>{fileName || 'No file chosen'}</FileName>
              <Button onClick={() => document.getElementById('logo-upload').click()}>Upload Logo</Button>
              <input
                id="logo-upload"
                type="file"
                style={{ display: 'none' }}
                onChange={handleFileChange}
                accept="image/*"
              />
            </FileInputContainer>
          </Tooltip>
        </Section>
        {/* <Section>
          <Heading marginBottom="1rem">Liquidity</Heading>
          <Text textAlign="left">{nativeCoinName} Amount</Text>
          <Tooltip
            title={`Enter the amount of ${nativeCoinName} you want to add as liquidity.`}
            placement="right-start"
          >
            <Input
              placeholder={`${nativeCoinName} amount`}
              name="ethPlsAmount"
              value={ethPlsAmount}
              onInput={validateInteger}
            />
          </Tooltip>
          <Text textAlign="left">{tokenName} Amount</Text>
          <Tooltip title="Specify the amount of your new tokens to add to the liquidity pool." placement="right-start">
            <Input
              placeholder="Token amount"
              name="liquidityTokenAmount"
              value={liquidityTokenAmount}
              onInput={validateInteger}
            />
          </Tooltip>
          {Number(ethPlsAmount) > 0 && Number(liquidityTokenAmount) === 0 ? (
            <p style={{ color: 'red' }}>Need set both values</p>
          ) : null}
          {Number(liquidityTokenAmount) > 0 && Number(ethPlsAmount) === 0 ? (
            <p style={{ color: 'red' }}>Need set both values</p>
          ) : null}
          {Number(liquidityTokenAmount) > 0 &&
            Number(tokenSupply) > 0 &&
            Number(liquidityTokenAmount) > Number(tokenSupply) ? (
            <p style={{ color: 'red' }}>Amount exceeds total supply and pool allocation amount</p>
          ) : null}
        </Section> */}
        <Section>
          <Text marginBottom="1rem" bold fontSize="16px">
            Pool Allocation
          </Text>
          <Text marginBottom="1rem" bold fontSize="16px">
            (Allows your {tokenName} Token to be earned by staking $BBC)
          </Text>
          <Slider
            min={0}
            max={100}
            value={percent}
            onValueChanged={handleChangePercent}
            name="stake"
            valueLabel={`${percent}%`}
            step={1}
          />

          {Number(poolAllocationTokenAmount) > 0 && Number(poolAllocationTokenAmount) > Number(tokenSupply) ? (
            <p style={{ color: 'red' }}>Amount exceeds total supply</p>
          ) : null}
          {Number(liquidityTokenAmount) > 0 &&
            Number(tokenSupply) > 0 &&
            Number(poolAllocationTokenAmount) > 0 &&
            Number(poolAllocationTokenAmount) > Number(tokenSupply) - Number(liquidityTokenAmount) ? (
            <p style={{ color: 'red', marginTop: '1rem' }}>Amount exceeds total supply and liquidity amount</p>
          ) : null}
        </Section>
        <ResumeSection>
          <b>Name:</b> {tokenName}
          <br />
          <b>Symbol:</b> {tokenSymbol}
          <br />
          <b>Supply:</b> {tokenSupply} {tokenSymbol}
          <br />
          <b>Liquidity:</b> {ethPlsAmount} {nativeCoinName} / {liquidityTokenAmount} {tokenSymbol} -{' '}
          {calculatePercentage(Number(tokenSupply), Number(liquidityTokenAmount))}
          <br />
          <b>Pool:</b> {poolAllocationTokenAmount} {tokenSymbol} -{' '}
          {calculatePercentage(Number(tokenSupply), Number(poolAllocationTokenAmount))}
          <br />
          <b>Amount left:</b> {Number(tokenSupply) - (Number(liquidityTokenAmount) + Number(poolAllocationTokenAmount))}{' '}
          {tokenSymbol} -{' '}
          {calculatePercentage(Number(tokenSupply), Number(liquidityTokenAmount) + Number(poolAllocationTokenAmount))}
          <br />
          <b>Price:</b> ${initialPrice.toFixed(2)} Per {tokenName} token
          <br />
          <b>Market Cap:</b> ${formatMarketCap(marketCap)}
        </ResumeSection>

        <p style={{ color: 'white' }}>Deployed tokens will be shown at the bottom of the page</p>
        <br />
        <p style={{ color: 'white' }}>
          This token deployer is a public good and free of charge, you will only pay for your own transactions
        </p>
        <br />
        {!account ? (
          <ConnectWalletButton width="100%" />
        ) : (
          <ResponsiveFlex>
            <Button
              disabled={
                isLoading ||
                Number(tokenSupply) === 0 ||
                (Number(poolAllocationTokenAmount) > 0 && Number(poolAllocationTokenAmount) > Number(tokenSupply)) ||
                Number(tokenSupply) < Number(poolAllocationTokenAmount) + Number(liquidityTokenAmount)
              }
              onClick={deploy}
            >
              Deploy {isLoading ? <Loading ml={10} width="16px" height="16px" /> : null}
            </Button>

            {/* {Number(ethPlsAmount) > 0 && Number(liquidityTokenAmount) > 0 ? <Button disabled={isLoading || Number(tokenConfig.ethLiquidityAmount) <= 0 || Number(tokenConfig.tokenLiquidityAmount) <= 0}
              onClick={addLiquidity}>
              Add Liquidity {isLoading ? <Loading ml={10} width="16px" height="16px" /> : null}
            </Button> : null} */}
          </ResponsiveFlex>
        )}

        <br />
        <br />
        <br />

        {deployedTokens.length > 0 ? (
          <>
            <Heading style={{ fontSize: '3rem' }}>Your tokens</Heading>
            <DeployedTokenSection>
              {deployedTokens.map((token, index) => {
                return (
                  <ResumeSection key={token.tokenAddress}>
                    {token.logoUrl ? (
                      <p style={{ textAlign: 'center' }}>
                        <img
                          alt="logo"
                          src={token.logoUrl ?? ''}
                          style={{ borderRadius: '50%', width: '48px', height: '48px' }}
                        />
                        <br />
                      </p>
                    ) : null}
                    <b>Name:</b> {token.name} <br />
                    <b>Symbol:</b> {token.symbol}
                    <br />
                    {token.logoUrl ? (
                      <Link href={token.logoUrl ?? ''} target="_blank" style={{ textDecoration: 'underline' }}>
                        Logo url
                        <br />
                      </Link>
                    ) : null}
                    <Link href={token.deployTxHash ?? ''} target="_blank" style={{ textDecoration: 'underline' }}>
                      Deploy tx
                    </Link>
                    <br />
                    Add to MM
                    <AddToWalletButton
                      marginLeft="10px"
                      variant="text"
                      p="0"
                      height="auto"
                      tokenAddress={token.tokenAddress}
                      tokenSymbol={token.symbol}
                      tokenDecimals={18}
                      tokenLogo={token.logoUrl}
                    />
                    <br />
                    <CopyButtonContainer>
                      <span>Copy CA</span>
                      <CopyButton
                        marginLeft="5px"
                        width="16px"
                        buttonColor="textSubtle"
                        text={token.tokenAddress}
                        tooltipMessage={`${token.symbol} address copied`}
                      />
                    </CopyButtonContainer>
                  </ResumeSection>
                )
              })}
            </DeployedTokenSection>
          </>
        ) : null}
      </Container>
      {isModalVisible && (
        <ModalContainer>
          <TransactionConfirmationModal
            title="Transaction Status"
            attemptingTxn={transactionStatus.attemptingTxn}
            hash={transactionStatus.hash}
            pendingText={transactionStatus.message}
            onDismiss={() => setIsModalVisible(false)}
            content={() => <div />}
            currencyToAdd={
              deployedToken
                ? new Token(
                  chainId,
                  deployedToken.address,
                  deployedToken.decimals,
                  deployedToken.symbol,
                  deployedToken.symbol,
                )
                : undefined
            }
            tokenLogo={tokenLogoUrl}
          />
        </ModalContainer>
      )}
    </Page>
  )
}
